// AUTO-GENERATED from `bush_1.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 45590,
    "type": "deciduous",
    "bark": {
      "type": "Bark001",
      "tint": 13552830,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 0.5,
        "y": 5
      }
    },
    "branch": {
      "levels": 3,
      "angle": {
        "1": 21.521739130434785,
        "2": 62.608695652173914,
        "3": 60
      },
      "children": {
        "0": 7,
        "1": 3,
        "2": 2
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0.0
      },
      "gnarliness": {
        "0": 0.11,
        "1": 0.09,
        "2": 0.05,
        "3": 0.09
      },
      "length": {
        "0": 0.1,
        "1": 15.302173913043479,
        "2": 5.59,
        "3": 4.6
      },
      "radius": {
        "0": 0.5793478260869566,
        "1": 0.9521739130434783,
        "2": 0.76,
        "3": 0.7
      },
      "sections": {
        "0": 6,
        "1": 6,
        "2": 10,
        "3": 10
      },
      "segments": {
        "0": 4,
        "1": 4,
        "2": 4,
        "3": 3
      },
      "start": {
        "1": 0.53,
        "2": 0.33,
        "3": 0
      },
      "taper": {
        "0": 0.7,
        "1": 0.7,
        "2": 0.7,
        "3": 0.7
      },
      "twist": {
        "0": 0.3,
        "1": -0.07,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "ash",
      "billboard": "double",
      "angle": 55,
      "count": 12,
      "start": 0,
      "size": 2.4456521739130435,
      "sizeVariance": 0.717,
      "tint": 14745557,
      "alphaTest": 0.5
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
